<h1 mat-dialog-title>{{ 'packagingSystem.packagingSystem' | transloco }}</h1>

<mat-dialog-content>
  <app-packaging-systems-overview [dataSource]="dataSource" [displayedColumns]="displayedColumns"
    [isUserValidator]="false" (packagingPartsSelected)="packagingSystemsSelected($event)">
  </app-packaging-systems-overview>
</mat-dialog-content>

<mat-dialog-actions>
  <button (click)="importPackagingSystems()" mat-raised-button type="submit" color="primary"
    [disabled]="selectedPackagingSystems.length === 0">
    {{ 'common.buttons.import' | transloco }}</button>
  <button (click)="closeDialog()" mat-raised-button type="button">
    {{ 'common.buttons.cancel' | transloco }}</button>
</mat-dialog-actions>
